export const iconFontAwesomeArrowsArrowUpAZ = (
	<i className="fa-solid fa-arrow-up-a-z"></i>
);
